import { AcceptButton, RejectButton } from '../../ui_components/buttons.js';
import { updateCardCoordinates } from '../../data/update_operations.js';
import stateManager from '../../data/state_manager.js';
import { SingleImagePanelWithCornerOverlay } from '../../ui_components/popups/two_image_panels.js';
import { fetchStreamingData } from '../../data/streaming.js';
import config from '../../../config/index.js';
import { hideOverlay, showOverlay } from '../../ui_components/overlay.js';

class FixCornersController {
  constructor(type, local_image_url, server_side_id) {
    const { currentFrontCoords, frontRotation } = stateManager.getState();
    this.type = type;
    this.should_reset_request_id = false;

    this.card_coordinates = currentFrontCoords;
    this.rotation = frontRotation;

    this.local_image_url = local_image_url;
    this.server_side_id = server_side_id;
    this.new_coordinates = null;

    this.closeButton = new RejectButton('Cancel');
    this.submitButton = new AcceptButton('Update Corners');
    this.view = new SingleImagePanelWithCornerOverlay(
      this.card_coordinates,
      this.rotation
    );
  }

  setTour(featureTour) {
    this.featureTour = featureTour;
  }

  createAndShowPopup(headers) {
    this.view.setImage(this.local_image_url);
    this.view.addButtonToLeft(this.closeButton, () => this.handleClose());
    this.view.addButtonToRight(this.submitButton, () =>
      this.handleSubmit(this.type, headers)
    );
    this.view.bindCloseButton(() => this.handleClose());
  }

  handleClose() {
    if (this.featureTour) {
      this.featureTour.show();
    }

    this.view.remove();

    if (this.should_reset_request_id) {
      stateManager.updateState({
        stopProcessing: true,
        alertOnMismatch: false,
      });
    }
  }

  shouldResetRequestId() {
    this.should_reset_request_id = true;
  }

  async handleSubmit(type, headers) {
    this.new_coordinates = this.view.getCorners();

    showOverlay();

    const payload = {
      parent_image_id: this.server_side_id,
      new_coordinates: this.new_coordinates,
      rotation_degrees: this.rotation,
    };

    const response = await updateCardCoordinates(headers, payload);

    console.log(response);

    const requestId = response.request_id;
    const controller = new AbortController();

    if (this.should_reset_request_id) {
      stateManager.updateState({ currentFrontRequestId: requestId });
    }

    // abortControllers.push(controller);
    fetchStreamingData(
      `${config.detectionUrl}/get-data-stream/${requestId}`,
      headers,
      (data) => this.handleProcessingComplete(type, data),
      controller.signal
    );
  }

  async handleProcessingComplete(type, data) {
    const { currentFrontRequestId } = stateManager.getState();

    stateManager.updateState({ currentFrontCoords: this.new_coordinates });
    this.view.remove();

    if (
      stateManager.hasCard(currentFrontRequestId) &&
      this.should_reset_request_id
    ) {
      stateManager.getNextCard(currentFrontRequestId);
    }

    if (this.onComplete) {
      this.onComplete(data); // Call the callback function
    }

    hideOverlay();
  }

  bindCompletionCallback(callback) {
    this.onComplete = callback;
  }
  bindOnClose(handler) {
    this.view.bindOnClose(handler);
  }
}

export { FixCornersController };
